import { SlotBookingState } from 'redux/modules/slot-booking/state/initial-state';

const reducer = (state: SlotBookingState) => ({
  ...state,
  gridLength: state.gridLength === 5 ? 3 : 5,
});

export default reducer;
